module.exports = __webpack_public_path__ + "static/img/Cannoli.5c62c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Cannoli.jpg
// module id = rxAH
// module chunks = 0